export const ANALYTICS_PURCHASE = "purchase";
export const ANALYTICS_ADD_TO_CART = "add_to_cart";
export const ANALYTICS_REMOVE_FROM_CART = "remove_from_cart";
export const ANALYTICS_VIEW_ITEM = "view_item";
export const ANALYTICS_SELECT_ITEM = "select_item";
export const ANALYTICS_VIEW_CART = "view_cart";
export const ANALYTICS_BEGIN_CHECKOUT = "begin_checkout";

export const RELATED_PRODUCTS_LIST_ID = "related_products";
export const RELATED_PRODUCTS_LIST_NAME = "Related products";

// PostHog ecommerce event constants
export const POSTHOG_ANALYTICS_PRODUCT_VIEWED = "Product Viewed";
export const POSTHOG_ANALYTICS_PRODUCT_CLICKED = "Product Clicked";
export const POSTHOG_ANALYTICS_PRODUCT_ADDED = "Product Added";
export const POSTHOG_ANALYTICS_PRODUCT_REMOVED = "Product Removed";
export const POSTHOG_ANALYTICS_CART_VIEWED = "Cart Viewed";
export const POSTHOG_ANALYTICS_CHECKOUT_STARTED = "Checkout Started";
export const POSTHOG_ANALYTICS_PAYMENT_STARTED = "Payment Started";
export const POSTHOG_ANALYTICS_ORDER_COMPLETED = "Order Completed";
export const POSTHOG_ANALYTICS_CAMPAIGN_EMAIL_LANDING = "campaign_email_landing";
export const POSTHOG_ANALYTICS_REPEAT_PURCHASE = "repeat_purchase";

// PostHog ecommerce metadata constants
export const POSTHOG_ANALYTICS_BRAND = "Het Vleescentrum";
export const POSTHOG_ANALYTICS_AFFILIATION = "Webshop";
export const POSTHOG_ANALYTICS_CURRENCY = "EUR";
export const POSTHOG_ANALYTICS_URL_BASE = process.env.REACT_APP_WEBSITE_URL;
